import React from 'react';
import { motion } from 'framer-motion';
const withoutKit = ['Sin sistema → no sabés cuánto ganás por producto', 'Sin calculadora → fijás precios sin certeza', 'Sin tracker → stock descontrolado, ventas perdidas', 'Sin plan → trabajás más pero no ganás más en términos reales'];
const withKit = ['Con el Sistema ML Rentable → ganancia neta exacta en segundos', 'Con el Simulador → precios y promos con datos reales', 'Con el Tracker → nunca más sin stock en el momento clave', 'Con el Plan 90 Días → crecimiento sistemático semana a semana'];
export function AgitationSection() {
  return <section className="bg-cream py-16 md:py-24" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-navy leading-tight max-w-4xl mx-auto" data-id="element-20">
            El problema no es que no trabajés duro.{' '}
            <span className="text-gold" data-id="element-21">
              Es que nadie te enseñó a medir lo que ganás.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-22">
          {/* Without Kit */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 border-l-4 border-red-500 shadow-sm" data-id="element-23">
            <h3 className="font-display font-bold text-xl text-navy mb-5" data-id="element-24">
              ❌ Sin el Kit
            </h3>
            <ul className="space-y-4" data-id="element-25">
              {withoutKit.map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/70 text-sm leading-relaxed" data-id="element-26">
                  <span className="text-red-500 mt-0.5 shrink-0" data-id="element-27">✗</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* With Kit */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 border-l-4 border-teal shadow-sm" data-id="element-28">
            <h3 className="font-display font-bold text-xl text-navy mb-5" data-id="element-29">
              ✅ Con el Kit
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {withKit.map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/70 text-sm leading-relaxed" data-id="element-31">
                  <span className="text-teal mt-0.5 shrink-0" data-id="element-32">✓</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}